import t from "styled-components";
import { Input as n } from "./atoms-v2747.js";
import { SkeletonInput as a } from "./atoms-v2747.js";
const i = t(n)`
  appearance: textfield;
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
  text-align: center;
  width: 2.5em;

  /* Hide number spinners */
  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    appearance: none;
    margin: 0;
  }
`;
export {
  i as Input,
  a as SkeletonInput
};
